import { Card, CardHeader, CardContent } from 'dreambel-ui';

interface FeatureCardProps {
  readonly title: string;
  readonly content: string;
}

export function FeatureCard({ title, content }: FeatureCardProps) {
  return (
    <Card
      elevation="none"
      variant="outlined"
      className="p-4 flex-1 w-full sm:max-w-[50%]"
    >
      <CardHeader>
        <h2 className="text-2xl font-semibold text-md-on-surface">{title}</h2>
      </CardHeader>
      <CardContent>{content}</CardContent>
    </Card>
  );
}
